/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DocumentClassification {
  Unknown = 0,
  ShippingLetter = 1,
  Import = 2,
  Export = 4,
  ProformaInvoice = 8,
  Invoice = 16,
  GoodsList = 32,
}
